import { getConfig } from '@config';
import React, { useEffect } from 'react';
import { ClarityLoaderScript } from './ClarityLoaderScript';
import { identifyWithClarity } from './identifyWithClarity';

/**
 * https://clarity.microsoft.com/
 * Free heatmaps & session recordings
 *
 */
export const ClarityService = () => {
  const isEnabled = getConfig().microsoftClarityEnabled;

  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    // Rendering this component injects the synchronous stub for `clarity`, so identifyWithClarity()
    // is queued right away and replayed once the async SDK finishes loading.
    identifyWithClarity();
  }, [isEnabled]);

  if (!isEnabled) {
    return null;
  }

  return <ClarityLoaderScript projectId="hvn8o07eqd" />;
};
